import { getFromSessionStorage } from '@/shared/utils/storage.util';
import { useEffect, useState } from 'react';

const useCountdown = (key: string, hours: number) => {
  const [remainingTime, setRemainingTime] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    // Check session storage for saved epoch using the key
    const now = new Date().getTime();
    const savedEpochString = getFromSessionStorage(key);
    let targetEpoch : any;

    if (savedEpochString && (typeof savedEpochString === 'string' || typeof savedEpochString === 'number')) {
      // If saved epoch exists, parse it and use it as targetEpoch
      const savedEpoch = parseInt(savedEpochString, 10);
      if (!isNaN(savedEpoch) && savedEpoch >= now) { // Check for valid number
        targetEpoch = savedEpoch;
      }
    }

    if (!targetEpoch) {
      // If no saved epoch or invalid, calculate using hours
      targetEpoch = new Date().getTime() + hours * 60 * 60 * 1000;
      // Save the calculated targetEpoch in session storage
      sessionStorage.setItem(key, targetEpoch.toString());
    }

    const intervalId = setInterval(() => {
      const now = new Date().getTime();
      const difference = targetEpoch - now;

      // Restart timer if difference is less than or equal to 0
      if (difference <= 0) {
        // Restart timer if difference is less than or equal to 0
        targetEpoch = now + hours * 60 * 60 * 1000;
      }

      // Calculate remaining hours, minutes, and seconds
      const remainingHours = Math.floor(difference / (1000 * 60 * 60));
      const remainingMinutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const remainingSeconds = Math.floor((difference % (1000 * 60)) / 1000);

      // Update state with remaining time
      setRemainingTime({ hours: remainingHours, minutes: remainingMinutes, seconds: remainingSeconds });
    }, 1000); // Update every second

    // Cleanup function to clear the interval on unmount
    return () => clearInterval(intervalId);
  }, [key, hours]); // Dependency on key and hours argument

  return remainingTime;
};

export default useCountdown;